import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export const formatDate = (date: string | null): string => {
  if (!date) return '-';
  return dayjs(date.replace('Z', '')).format('DD MMM YYYY HH:mm');
};

export const formatDateUtc = (date: string | null): string => {
  if (!date) return '-';
  return dayjs.utc(date).format('DD MMM YYYY HH:mm');
};

export const formatDateOnly = (date: string | null): string => {
  if (!date) return '-';
  return dayjs(date.replace('Z', '')).format('DD MMM YYYY');
};

export const formatBirthMonthYear = (date: string | null): string => {
  if (!date) return '-';
  return dayjs.utc(date).format('MMM YYYY');
};

export const formatDateWithTimezone = (date: string | null, timezone: string = 'UTC'): string => {
  if (!date) return '-';
  return dayjs.utc(date).format(`DD-MM-YYYY HH:mm:ss [${timezone}]`);
};

export const isValidDateRange = (start: string | null, end: string | null): boolean => {
  if (!start || !end) return true;
  return dayjs.utc(start).isSameOrBefore(dayjs.utc(end));
};

export const isDateInRange = (
  date: string | null,
  start: string | null,
  end: string | null,
): boolean => {
  if (!date) return false;

  const dateObj = dayjs.utc(date);

  if (start && !dateObj.isSameOrAfter(dayjs.utc(start))) return false;
  if (end && !dateObj.isSameOrBefore(dayjs.utc(end))) return false;

  return true;
};
